<nk-screening-case-table
  [screeningEntityUuid]="entity.data.screening_entity.uuid"
  [screeningCaseComposites]="entity.data.screening_case_composites"
  [isPrintVersion]="isPrintVersion">
</nk-screening-case-table>
<nk-screening-adverse-media-card-list
  [screeningEntityUuid]="entity.data.screening_entity.uuid"></nk-screening-adverse-media-card-list>
